var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "balloonTemplateData",
    class: _vm.templateData.length != 0 ? 'active' : null,
    style: [_vm.movePostion]
  }, [_c('p', {
    staticClass: "balloon"
  }, [_vm._v("템플릿을 삽입할 위치를 클릭하여 주세요.")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }